import { generatedProductGuideApi } from '@store/generated/jot-worker/product-guide';

export const guideApi = generatedProductGuideApi.enhanceEndpoints({
  endpoints: {
    getProductGuideTopics: { extraOptions: { access: 'public' } },
    searchProductGuideArticles: { extraOptions: { access: 'public' } },
    getProductGuideArticle: { extraOptions: { access: 'public' } },
  },
});
export const useGuideTopics = guideApi.endpoints.getProductGuideTopics.useQuery;
export const useGuideSearch = guideApi.endpoints.searchProductGuideArticles.useQuery;
export const useGuideArticle = guideApi.endpoints.getProductGuideArticle.useQuery;
